<template>
  <div>
    <card>
      <div class="row">
          <div class="col">
              <h1 style="color:#00467f;text-align:left;font-weight:bold">Asseverazioni</h1>
          </div>
          <div class="col">
              <span class="float-right" style="margin-right:20px">
                  <div class="search-bar input-group"  @click="searchModalVisible = true">
                      <button class="btn btn-link" id="search-button" data-toggle="modal" data-target="#searchModal"><i class="tim-icons icon-zoom-split"></i>
                      <span class="d-lg-none d-md-block">Search</span>
                      </button>
                  </div>
                  <modal :show.sync="searchModalVisible"
                          class="modal-search"
                          id="searchModal"
                          :centered="false"
                          :show-close="true">
                      <input type="text" id="ricerca" class="form-control" v-on:keyup="cerca()" name="ricerca" placeholder=" Cerca...">
                  </modal>
              </span>
          </div>
      </div>
      <div class="row" style="margin-left:5px;margin-bottom:20px">
          <span class="float-left">
              <router-link :to="'/crea-asseverazione'"><button class="btn" type="button" style="background:#00467f">Crea Asseverazione</button></router-link>
          </span>
      </div>
      
      <div class="row">
          <div class="col-5">
              <p style="text-align:left; margin-left:20px">FILTRA PER:<br>
              <ul style="list-style-type: none;">
                  <li>
                    ...
                  </li>
              </ul>
              </p>
          </div>
          <div class="col-5"></div>
          <div class="col-2"></div>
      </div>
      <!-- <hr> -->
      <div class="row" style="margin-top:10px">
          <div style="margin-left:80px;font-weight:bold">
              <label>Numero di righe per pagina:</label>
              <select v-model="n_righe" v-on:change="caricaAsseverazioni()" style="border: 2.5px solid;border-radius:0.25em;border-color:#00467f;background-color: #fff;width:100%;max-width: 100px;margin-left:30px">
                  <option disabled value="">Please select one</option>
                  <option value="15">15</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
              </select>
          </div>
      </div>
      <div class="row justify-content-center" style="margin-bottom:30px;margin-top:20px">
        <div class="col-4">
          <div v-if="page != 1"><button v-on:click="changePage('indietro')" style="color:#00467f;padding: 0;border: none;background: none;"><i class="tim-icons icon-minimal-left" style="font-size:20px;color:#00467f"></i></button></div>
          <div v-else></div>
        </div>
        <div class="col-4">
          <p>Pagina <strong>{{page}}</strong> di <strong>{{totPage}}</strong></p>
        </div>
        <div class="col-4">
          <div v-if="page < totPage"><button v-on:click="changePage('avanti')" style="color:#00467f;padding: 0;border: none;background: none;"><i class="tim-icons icon-minimal-right" style="font-size:20px;color:#00467f"></i></button></div>
          <div v-else></div>
        </div>
      </div>
      <table class="table tablesorter" id="tabella" style="text-align: center">
        <thead>
          <tr>
            <th>DATA</th>
            <th>AZIENDA</th>
            <th>CF</th>
            <th>REFERENTE AZIENDA</th>
            <th>TEL</th>
            <th>MAIL</th>
            <th>TIPO BONUS</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr class="row-color"  v-for="valori in allAsseverazioni" v-bind:key="valori.ID">
            <td>{{valori.DATA}}</td>
            <td>{{valori.DENOMINAZIONE_DITTA}}</td>
            <td>{{valori.CF}}</td>
            <td>..</td>
            <td>..</td>
            <td>...</td>
            <td>{{valori.ID_TIPOLOGIA}}</td>
            <td>
              <router-link :to="'/modifica-asseverazione?' + 'idAsseverazione=' + valori.ID + '&idBonus='+valori.ID_TIPOLOGIA"><i class="tim-icons icon-pencil" style="color:#00467f"></i></router-link>
             </td>
          </tr>
        </tbody>
      </table>
  </card>
  </div>
</template>
<script>
import Card from '../../components/Cards/Card.vue';
import Modal from "@/components/Modal.vue";
import Services from '@/services/Services';
import AsseverazioniServices from '@/services/AsseverazioniServices';
import axios from 'axios';

// import moment from 'moment';

export default {
  components: {
    Card, Modal
  },
  /**
   * Chart data used to render stats, charts. Should be replaced with server data
   */
  data() {
    return {
      searchModalVisible: false,
      show50: false,
      show90: false,
      show100: false,
      show: false,
      bonus: null,

      // per mostrare pagine
      n_righe: 15,
      page: 1,
      totPage: null,
      asseverazioni: [],
      allAsseverazioni: [],
      cerca_info: [],
      access_token: null,
      token_response: [],
      user_livello: null,

      // per ordinare righe tabella
      currentSort:'ID',
      currentSortDir:'desc',

      urlRichieste: 'https://sviluppoallergeni.confcom.it/'
    };
  },
  methods: {
    cerca: async function() {
      let input, filter, table, tr, td, i, txtValue;
      input = document.getElementById("ricerca");
      filter = input.value.toUpperCase();
      table = document.getElementById("tabella");
      tr = table.getElementsByTagName("tr");
      let arrayFiltrato = [];
      for (i = 0; i < this.asseverazioni.length; i++) {
        txtValue = this.asseverazioni[i].DENOMINAZIONE_DITTA;
        if (txtValue.toUpperCase().indexOf(filter) > -1) {
          arrayFiltrato.push(this.asseverazioni[i]);
        }
      }
      this.asseverazioni = arrayFiltrato;
      if (filter == "") {
        await this.main();
      }
    },

    caricaAsseverazioni: async function() {
      let errore = 0;
      await AsseverazioniServices.getAsseverazioni()
      .then(response => { this.allAsseverazioni = response.data})
      .catch( async function (error) {
        // handle error
        if(error.response.status == 401){
          errore = error.response.status;
          console.log(`errore = ${errore}`);
        }
      })
      if (errore == 401) {
        let value = await Services.refreshTokenFunction();//await this.refreshToken();
        if (value) { await this.caricaAsseverazioni(); }
      }
      console.log(`allAsseverazioni`);
      console.log(this.allAsseverazioni);
    },

    main: async function() {
      this.user_livello = localStorage.getItem('user_livello');
      axios.defaults.withCredentials = true;
      this.access_token = localStorage.getItem('access_token');
      try {
          this.caricaAsseverazioni();
      } catch (error) {
          console.log(`error try/catch = ${error}`);
          console.log(`error.response try/catch = ${error.response}`);
          console.log(`error.response.status try/catch = ${error.response.status}`);
          if (error.response.status == 401) {
              await Services.refreshTokenFunction();
          }
      }
    },
    
  },
  mounted() {
      this.main();
    }
};
</script>
<style>
  h3 {
    color:black;
    text-align: left;
  }
  .rectangle {
    height: 180px;
    /* width: 10px; */
    display: inline;
    margin-right: 70px;
    margin-left: 70px;
    margin-top: 20px;
    float: left;
    border-style: solid;
    border-color: #00467f;
    border-width: 5px;
    line-height: 200px;
    cursor: pointer;
  }

  .box-text {
    display: inline-block;
    text-align: center;
    line-height: normal;
    vertical-align: middle;
    font-weight: bold;
    color: #00467f;
  }
</style>
